import React from "react";
import useLanguageProvider from "components/LanguageProvider/hooks/useLanguageProvider";

const ModalLoginContainer = ({
  type,
  modalTitle,
  isError,
  errorMessage,
  switchLoginOrSignupHandler,
  classPrefix = "comment-modal",
  children,
}) => {
  const { translate: t } = useLanguageProvider();
  const footerAction = (modalType) => {
    if (modalType === "signup") {
      return (
        <div className={`${classPrefix}__footer-action`}>
          {t("Already have an account?")}
          &nbsp;
          <button
            type="button"
            className={`${classPrefix}__footer-link`}
            onClick={switchLoginOrSignupHandler}
          >
            {t("Login")}
          </button>
          {" "}
          {t("instead.")}
        </div>
      );
    }
    return (
      <div className={`${classPrefix}__footer-action`}>
        {t("New to Chuffed?")}
        &nbsp;
        <button
          type="button"
          className={`${classPrefix}__footer-link`}
          onClick={switchLoginOrSignupHandler}
        >
          {t("Signup")}
        </button>
        {" "}
        {t("instead.")}
      </div>
    );
  };

  return (
    <div className={`${classPrefix}__content`}>
      <div className={`${classPrefix}__header`}>
        <div className={`${classPrefix}__heading`}>{modalTitle}</div>
      </div>
      <div className={`${classPrefix}__body`}>
        {(isError === true
          || (errorMessage && errorMessage !== "Multifactor Authentication Code required")) && (
          <div className={`${classPrefix}__error-message`}>{errorMessage}</div>
        )}
        {
          children
        }
      </div>
      <div className={`${classPrefix}__footer`}>
        {footerAction(type)}
      </div>
    </div>
  );
};

export default ModalLoginContainer;
